/* eslint-disable no-useless-constructor */
// eslint-disable-next-line max-classes-per-file
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on an accordion heading on homepage footer links section and collapses.
 *
 * &nbsp;
 */
export class HomePageFooterAccordionCollapsed extends AnalyticsEvent {
  eventName = 'home-page-footer-acoordion-collapsed';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;

  constructor(eventProperties: { dropDownName: string }) {
    super(eventProperties);
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when user clicks on an accordion heading on homepage footer links section and expands.
 *
 * &nbsp;
 */
export class HomePageFooterAccordionExpanded extends AnalyticsEvent {
  eventName = 'home-page-footer-acoordion-expanded';

  consentPurpose: ConsentPurpose = 'performance';

  concept = CONCEPTS.marketing.growth;

  constructor(eventProperties: { dropDownName: string }) {
    super(eventProperties);
  }
}
